export default {
  attributes: { breakpoints: { type: 'identity' } },
  icon: null,
  name: 'GRID_ITEM',
  title: 'Grid Item',
  v: 0,
};
